/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2022-2024 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

// this is a react component that encapsulates the username and password form .
// It uses the authentactionservice to autheticate with tririga and then
// pushes the session token to the local sessionStorage.

import React from 'react';
import "../login-form/LoginForm.scss";
import { AuthenticationService } from '../service/AuthenticationService';

import { Button, Form, TextInput, Link, UnorderedList, ListItem } from 'carbon-addons-iot-react';
import { ArrowRight32 } from '@carbon/icons-react';
import { InlineNotification } from "carbon-components-react";
import { AppMsg } from "../utils";

const BLANK = '';

export class ChangePwdForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: this.props.username,
            enteredUsername: BLANK,
            oldPassword: this.props.password,
            newPassword: '',
            confirmNewPassword: '',
            errorMessage: '',
            errorMessageTitle: '',
            disableContinue: true,
            isPasswordRulesNotMet: false,
            isNoPasswordMatch: false,
            height: window.innerHeight
        }

        this.passwordRules = this.props.passwordRules;
        this.customPasswordRules = this.props.customPasswordRules;
    }

    _setOldPassword(pwd) {
        this.setState({
            oldPassword: pwd
        }, () => { this._validateInputFields() });
    }

    _setNewPassword(pwd) {
        this.setState({
            newPassword: pwd,
            isPasswordRulesNotMet: false
        }, () => { this._validateInputFields() });
    }

    _setConfirmNewPassword(pwd) {
        this.setState({
            confirmNewPassword: pwd
        }, () => { this._validateInputFields() });
    }

    _setEnteredUsername(name) {
        this.setState({
            enteredUsername: name
        }, () => { this._validateInputFields() });
    }

    _validateInputFields() {
        if (this._isOnUsernameAndCurrentPasswordForm()) {
            if (!this._isEnteredUsernameBlank() && this.state.oldPassword !== BLANK && this.state.errorMessage === BLANK) {
                this.setState({
                    disableContinue: false
                });
            } else {
                this.setState({
                    disableContinue: true
                });
            }
            return;
        }
        //if username and password fields are not empty then enable continue button
        if (this.state.oldPassword !== '' && this.state.newPassword !== '' && this.state.confirmNewPassword !== '' && 
            this.state.newPassword === this.state.confirmNewPassword && 
            this.state.errorMessage === '') {
            this.setState({
                disableContinue: false,
                isNoPasswordMatch: false
            });
        } else {
            this.setState({
                disableContinue: true
            });
            if ((this.state.newPassword !== '' && this.state.confirmNewPassword !== '') &&
                    this.state.newPassword !== this.state.confirmNewPassword) {
                this.setState({
                    isNoPasswordMatch: true
                });
            } else {
                this.setState({
                    isNoPasswordMatch: false
                });
            }
        }
    }

    _enableContinueButton() {
        this.setState({
            errorMessage: '',
            errorMessageTitle: ''
        }, () => { this._validateInputFields() });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this._isOnUsernameAndCurrentPasswordForm()) {
            //Handle submit enter username and password form.
            this._handleSubmitForEnteredUserAndCurrentPwd();
            return;
        }
        AuthenticationService.changePassword(this.state.username, 
                                            this.state.oldPassword, 
                                            this.state.newPassword,
                                            this.state.confirmNewPassword).then(
            () => {
                this.props.showPwdSuccessfulLoginForm();
            },
            error => {
                this._handleChangePwdError(error);
            }
        );
    }

    async _handleSubmitForEnteredUserAndCurrentPwd() {
        try {
            await this._handlePasswordRules(this.state.enteredUsername);
            await AuthenticationService.changePasswordCurrentPwdValidationOnly(
                this.state.enteredUsername,
                this.state.oldPassword
            );
            this.setState({
                username: this.state.enteredUsername,
                disableContinue: true,
                isCurrentPasswordInvalid: false,
                isPasswordRulesNotMet: false,
                isNoPasswordMatch: false
            });
            this._clearEnteredUserName();
        } catch (error) {
            this._handleChangePwdError(error);
        }
    }
    
    _handlePasswordRules(username) {
        return new Promise((resolve, reject) => {
            if (Object.keys(this.passwordRules).length === 0) {
                Promise.all([
                    AuthenticationService.initPasswordRules(),
                    AuthenticationService.initCustomPasswordRules(username)
                ]).then(([passwordRules, customPasswordRules]) => {
                    this.passwordRules = JSON.parse(passwordRules);
                    this.customPasswordRules = customPasswordRules;
                    resolve();
                }).catch(error => {
                    console.error('Error initializing password rules:', error);
                    reject(error);
                });
            } else {
                resolve();
            }
        });
    }

    _handleChangePwdError(error) {
        if (error && error.includes("Invalid username or password")) {
            if (this._isOnUsernameAndCurrentPasswordForm()) {
                this.setState({
                    isPasswordRulesNotMet: false,
                    errorMessage: AppMsg.getMessage(AppMsg.APP_ENTER_VALID_USERNAME_PASSWORD),
                    errorMessageTitle: AppMsg.getMessage(AppMsg.APP_ERROR_INVALID_USERNAME_PASSWORD),
                    disableContinue: true
                });
            } else {
                this.props.handleInvalidUserOrPwdForMainLogin(this.state.username, this.state.oldPassword);
                this._clearChangePasswordFormValues();
            }
        } else if (error && error.includes("Password does not meet the required criteria")) {
            this.setState({
                isPasswordRulesNotMet: true,
                disableContinue: true
            });
        } else {
            this.setState({
                isPasswordRulesNotMet: false,
                errorMessage: AppMsg.getMessage(AppMsg.APP_SYSTEM_ERROR_PWD),
                errorMessageTitle: AppMsg.getMessage(AppMsg.APP_ERROR),
                disableContinue: true
            });
        }
   }

    _handleAutofill(e) {
        if (e.animationName === "onAutoFillStart") {
            console.log('Auto Fill Detected');
            //This will fail if only user name is filled by browser and empty password
            this._enableContinueButton();
        }
    }

    _getPasswordRulesDisplay() {
        //First reset loginWrapper minHeight to account for rules
        if (process.env.NODE_ENV !== 'development') {
            window.parent.parent.document.querySelector("#loginWrapper").style.minHeight = "868px";
        }

        const customRulesListItems = this.customPasswordRules.map(
            (rule, index) => <ListItem key={index}>{rule}</ListItem>
        );

        return ( 
            <>{
            this.passwordRules.triEnforcePasswordRulesBL === "true" ? 
                <>
                    <div>
                        <label style={{fontSize:"12px"}}>{AppMsg.getMessage(AppMsg.APP_PWD_RULES_CONSIST_OF)}</label>             
                    </div>
                    <div style={{margin:"17px", marginTop:"4px", marginBottom:"0px"}}>
                        <UnorderedList style={{fontSize:"12px"}}>
                            <ListItem>{this._getMinMaxCharacterMessage()}</ListItem>
                            <>{Number(this.passwordRules.triHistPwdCountLI) > 1 ? 
                                        <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_HISTORY_COUNT).replace("{1}", this.passwordRules.triHistPwdCountLI)}</ListItem>: 
                                        <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_HISTORY_PREVIOUS)}</ListItem>}</>
                            <>{this.passwordRules.triNumbersReqLI === "Required" ? <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_NUMBER_REQ)}</ListItem>: ''}</>
                            <>{this.passwordRules.triLowercaseReqLI === "Required" ? <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_LOWERCASE_REQ)}</ListItem>: ''}</>
                            <>{this.passwordRules.triUppercaseReqLI === "Required" ? <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_UPPERCASE_REQ)}</ListItem>: ''}</>
                            <>{this.passwordRules.triSpecialCharactersReqLI === "Required" ? <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_SPECIAL_REQ)}</ListItem>: ''}</>
                            <><ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_NOT_CONTAIN_USERNAME)}</ListItem></>
                            <>{customRulesListItems}</>
                        </UnorderedList> 
                    </div>
                    <>{this._getPasswordOptionalRulesDisplay()}</>
                </>
                :  
                <>
                <div style={{minHeight:"15px"}}>
                    <label style={{fontSize:"12px"}}>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_NOT_SAME_AS_PREVIOUS)}</label>
                </div>
                </>
            }</>
        )
    }

    _getMinMaxCharacterMessage() {
        let message = AppMsg.getMessage(AppMsg.APP_PWD_RULE_MIN_MAX_CHARS).replace("{1}", this.passwordRules.triMinPwdLengthNU);
        return message.replace("{2}", this.passwordRules.triMaxPwdLengthNU);
    }

    _getPasswordOptionalRulesDisplay() {
        let minOptionalRulesReq = Number(this.passwordRules.triMinOptionalReqsNU);
        if (minOptionalRulesReq > 0) {
            let actualOptionalRulesCount = 0;
            if (this.passwordRules.triLowercaseReqLI === "Optional") {
                actualOptionalRulesCount++;
            }
            if (this.passwordRules.triUppercaseReqLI === "Optional") {
                actualOptionalRulesCount++;
            }
            if (this.passwordRules.triNumbersReqLI === "Optional") {
                actualOptionalRulesCount++;
            }
            if (this.passwordRules.triSpecialCharactersReqLI === "Optional") {
                actualOptionalRulesCount++;
            }
            if (actualOptionalRulesCount < minOptionalRulesReq) {
                minOptionalRulesReq = actualOptionalRulesCount;
            }
            return (  
                actualOptionalRulesCount > 0 ?
                <>
                <div style={{margin:"0px", marginTop:"5px", marginBottom:"0px"}}>
                    <label style={{fontSize:"12px"}}>{AppMsg.getMessage(AppMsg.APP_PWD_RULES_OPTIONAL_CONSIST_OF).replace("{1}", minOptionalRulesReq)}</label>             
                </div>
                <div style={{margin:"17px", marginTop:"4px", marginBottom:"0px"}}>
                    <UnorderedList style={{fontSize:"12px"}}>
                        <>{this.passwordRules.triNumbersReqLI === "Optional" ? <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_NUMBER_OPTIONAL)}</ListItem>: ''}</>
                        <>{this.passwordRules.triLowercaseReqLI === "Optional" ? <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_LOWERCASE_OPTIONAL)}</ListItem>: ''}</>
                        <>{this.passwordRules.triUppercaseReqLI === "Optional" ? <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_UPPERCASE_OPTIONAL)}</ListItem>: ''}</>
                        <>{this.passwordRules.triSpecialCharactersReqLI === "Optional" ? <ListItem>{AppMsg.getMessage(AppMsg.APP_PWD_RULE_SPECIAL_OPTIONAL)}</ListItem>: ''}</>
                    </UnorderedList> 
                </div>
                </>
                : ''
            )
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }
    
    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize);
    }
    
    handleResize = () => {
       this.setState({height: window.innerHeight});
    };

    _isOnUsernameAndCurrentPasswordForm() {
        //If state username is blank, then we are on the username and password form.
        return this.state.username === null || this.state.username === BLANK;
    }

    _isEnteredUsernameBlank() {
        return this.state.enteredUsername === null || this.state.enteredUsername === BLANK;
    }

    _clearChangePasswordFormValues() {
        this.setState({
            oldPassword: BLANK,
            newPassword: BLANK,
            confirmNewPassword: BLANK,
            username: BLANK
        });
    }

    _clearEnteredUserName() {
        this.setState({
            enteredUsername: BLANK
        });
    }

    render() {
        return (
            <div className="login-main-wrapper" style={{ height: this.state.height }} >
                <div className='login-wrapper'>
                    <div className={this._isOnUsernameAndCurrentPasswordForm() ? "login-header": "login-header-new-pwd"}>
                        <div>
                            <label>{AppMsg.getMessage(AppMsg.APP_CREATE_NEW_PASSWORD)}</label>
                        </div>
                    </div>
                    <div className="login-user-message">
                        {this._isOnUsernameAndCurrentPasswordForm() ? 
                            <label>{AppMsg.getMessage(AppMsg.APP_CREATE_NEW_PASSWORD_MSG)}</label> :
                                <label>{AppMsg.getMessage(AppMsg.APP_LOGGIN_IN_AS_MSG).replace("{1}", this.state.username) + " "}</label>
                        }
                    </div>
                    {this.state.errorMessage ?
                        <div className="tri-inline-notification-div">
                            <InlineNotification
                                hideCloseButton={false}
                                iconDescription="close"
                                kind="error"
                                notificationType="inline"
                                onCloseButtonClick={() => this._enableContinueButton()}
                                role="alert"
                                statusIconDescription=""
                                subtitle={this.state.errorMessage}
                                title={this.state.errorMessageTitle} />
                        </div> : ''
                    }
                    <hr className='horizontal-line' />
                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        {this._isOnUsernameAndCurrentPasswordForm() ?
                            <>
                                <div>
                                    <TextInput
                                        labelText={AppMsg.getMessage(AppMsg.APP_USERNAME)}
                                        id='username'
                                        placeholder={AppMsg.getMessage(AppMsg.APP_ENTER_USERNAME)}
                                        type="text" value={this.state.enteredUsername}
                                        onChange={(e) => this._setEnteredUsername(e.target.value)}
                                        onAnimationStart={(e) => this._handleAutofill(e)}
                                    />
                                </div>
                                <div>
                                    <TextInput.PasswordInput
                                        labelText={AppMsg.getMessage(AppMsg.APP_OLD_PASSWORD)}
                                        id='oldPassword'
                                        placeholder={AppMsg.getMessage(AppMsg.APP_ENTER_OLD_PASSWORD)}
                                        type="password"
                                        onChange={(e) => this._setOldPassword(e.target.value)}
                                        value={this.state.oldPassword} />
                                </div>
                            </>:
                        <div style={{marginBottom: "1px"}}>
                            <div>
                                <TextInput.PasswordInput
                                    labelText={AppMsg.getMessage(AppMsg.APP_NEW_PASSWORD)}
                                    id='newPassword'
                                    placeholder={AppMsg.getMessage(AppMsg.APP_ENTER_NEW_PASSWORD)}
                                    type="password"
                                    invalid={this.state.isPasswordRulesNotMet}
                                    invalidText={AppMsg.getMessage(AppMsg.APP_ERROR_PASSWORD_RULES_NOT_MET)}
                                    onChange={(e) => this._setNewPassword(e.target.value)}
                                    value={this.state.newPassword} />
                            </div>
                            <div>
                                <TextInput.PasswordInput
                                    labelText={AppMsg.getMessage(AppMsg.APP_CONFIRM_NEW_PASSWORD)}
                                    id='confirmNewPassword'
                                    placeholder={AppMsg.getMessage(AppMsg.APP_ENTER_CONFIRM_NEW_PASSWORD)}
                                    type="password"
                                    invalid={this.state.isNoPasswordMatch}
                                    invalidText={AppMsg.getMessage(AppMsg.APP_ERROR_NEW_PASSWORD_NO_MATCH)}
                                    onChange={(e) => this._setConfirmNewPassword(e.target.value)} 
                                    value={this.state.confirmNewPassword} />
                            </div>
                            <div
                                className="pwdRulesContainer"
                                style={{
                                    marginTop:"20px",
                                    maxHeight:"161px",
                                    overflow:"auto",
                                }}
                            >
                                {this._getPasswordRulesDisplay()}
                            </div> 
                        </div>
                        }
                        <div>
                            <Button
                                kind="primary"
                                size="field"
                                renderIcon={ArrowRight32}
                                onClick={(e) => {this.handleSubmit(e)}}
                                type="submit"
                                disabled={this.state.disableContinue}>
                                {AppMsg.getMessage(AppMsg.APP_CONTINUE)}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

export default ChangePwdForm;